/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import ImageOptimize from '../ImageOptimize'
import { FilterGroup } from './FilterGroup'

interface FilterHighlightType {
  className?: string
  filterGroup: Property
  onChange: (params: any, routerChange?: boolean) => void
  activeFilters: {
    name: string
    values: string[]
  }[]
}

export const FilterHighlight = ({
  className,
  filterGroup,
  activeFilters = [],
  onChange = () => true,
}: FilterHighlightType) => {
  return (
    <div
      className={`flex px-2 w-full gap-x-2 text-center overflow-y-hidden overflow-x-auto hiddenScrollBar scrollBarXCS ${className}`}
    >
      {filterGroup.values.length > 0 &&
        filterGroup.values.map((t, index) => (
          <FilterGroup
            type='button'
            className='w-max overflow-hidden bg-white'
            key={`quick-${index}`}
            option={t}
            isQuickFilter={true}
            activeOption={activeFilters.find(
              (f: any) => f.name === getPath(filterGroup.slugs)
            )}
            onChange={onChange}
          >
            {t.image ? (
              <ImageOptimize
                className='h-7 w-auto object-cover'
                src={t.image}
                alt={getTranslate(t.value)}
                width={240}
                height={100}
                loading='lazy'
              />
            ) : (
              <span className='inline-block text-center text-xs capitalize font-medium text-dark-400'>
                {getTranslate(t.value)}
              </span>
            )}
          </FilterGroup>
        ))}
    </div>
  )
}
